import api from '@/configurations/service';
import * as types from './mutation-types';

export const setCityCollection = async (context, payload) => {
  const body = { isUF: true, search: payload };

  const { data } = await api().post('core.get-city', body);

  context.commit(types.SET_CITY_COLLECTION, data);
};

export const setCityByCode = async (context, payload) => {
  const body = { code: payload };

  const { data } = await api().post('core.get-city-by-code', body);

  return data;
};
